import React from "react";
import styled from "styled-components";

const BarWrapperHorisontal = styled.div<HorizontalFillBarProps>`
    width: 100%;
    background-color: ${props => props.backgroundColor || 'white'};
    border:${props => props.border===undefined ? 'none' : props.border};
    height: ${props => props.height || "30px"};
`

const BarSingle = styled.div<{color:string, fillPct:number, height?:string}>`
    background: ${({ color }) => color};
    height: 100%;
    width: ${({ fillPct: width }) => width}%;
    transition: width 1s;
`

type HorizontalFillBarProps = {
    fillPct:number,
    fillColor:string,
    backgroundColor?:string,
    border?:string,
    height?:string,
}
export function HorizontalFillBar(props:HorizontalFillBarProps):JSX.Element
{
    
    return (
        <BarWrapperHorisontal {...props}>
            <BarSingle color={props.fillColor} fillPct={props.fillPct} height={props.height} />
        </BarWrapperHorisontal>
    );
}